import { createSelector } from '@ngrx/store';
import { getAdditionalServicesState } from './state.selector';

export const getProtectionState = createSelector(
  getAdditionalServicesState,
  (state) => state?.protection
);

export const isProtectionSelected = createSelector(
  getProtectionState,
  (state) => !!state?.data
);
